import React from "react";
import ADA_Statement from "../../PicesForPages/ADA_Statement.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function AdaAccessibilityStatement() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={ADA_Statement}
          alt="NewsPaperImage"
          className="background-video ADA_StatementImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>ADA Accessibility Statement</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              <span className="brand_text">VIDHI MORTGAGE LLC</span> is
              dedicated to delivering a website that is fully accessible to all
              customers and aligned with recognized accessibility standards. We
              continuously enhance our platform to uphold these standards,
              ensuring accessibility remains a core focus of our design and
              development.
            </span>
            <span className="purchaseBottomLeftContent">
              If you require assistance or have any questions or feedback
              regarding the accessibility of this website, please reach out to
              us a{" "}
              <a
                href="mailto: contact@vidhimortgage.com"
                style={{
                  textDecoration: "none",
                  color: "#005bb5",
                  fontWeight: "bold",
                }}
              >
                contact@vidhimortgage.com
              </a>
            </span>
            <span className="purchaseBottomLeftContent">
              Should you encounter any inaccessible areas on our site, we kindly
              ask you to notify our team by emailing{" "}
              <a
                href="mailto: contact@vidhimortgage.com"
                style={{
                  textDecoration: "none",
                  color: "#005bb5",
                  fontWeight: "bold",
                }}
              >
                contact@vidhimortgage.com
              </a>{" "}
              so we can address the issue promptly.
            </span>
            <span className="purchaseBottomLeftContent">
              If a particular page cannot be made fully accessible, we will
              gladly work with you to provide an alternative text-based version
              of the content.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now!
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default AdaAccessibilityStatement;
